import { t } from 'react-multi-lang';

const getTranslation = (key, args) => {
    return t(key, args)
}

export default getTranslation